export enum Queries {
  Environment = 'environment',
  GetVoteEditInfos = 'get-vote-infos',
  Cookies = 'cookies',
  GetMetadados = 'get-metadados',
  GetGuest = 'get-guest',
  GetBranchAndNucleou = 'get-branch-and-nucleou',
  GetSummonedReport = 'get-summoned-report',
  GetAttendanceReport = 'get-attendance-report',
  GetAttendancePdfReport = 'get-attendance-pdf-report',
  GetReports = 'get-reports',
  GetReportInfo = 'get-report-info',
  GetReportQuorum = 'get-report-quorum',
  GetReportMessage = 'get-report-message',
  GetReportVoting = 'get-report-voting',
  GetReportEvent = 'get-report-event',
  GetReportGuest = 'get-report-guest',
  GetReportSurvey = 'get-report-survey',
  GetNotifications = 'get-notifications',
  GetDuvidasAssessor = 'get-duvidas-assessor',
  GetDuvidasEventoAssessor = 'get-duvidas-evento-assessor',
}

export enum Mutations {
  PostEditVotes = 'post-edit-votes',
  PostReportGenerate = 'post-report-generate',
  PostPresencePages = 'post-presence-pages',
  PostAdicionarConvidado = 'post-adicionar-convidado',
  PutMarcarLido = 'put-marcar-lida',
}
